import SubscriptionAction from '../../components/membership/update/views/options/subscription-action';

interface GetProgramDescriptionTranslationKeysParams {
  hours?: number;
  isContract?: boolean;
  subscriptionAction?: SubscriptionAction;
}

function getProgramDescriptionTranslationKeys({
  hours = 0,
  isContract = false,
  subscriptionAction = SubscriptionAction.change,
}: GetProgramDescriptionTranslationKeysParams) {
  if (hours === 0) {
    return 'recommended_pay_as_you_go_description';
  }

  if (subscriptionAction === SubscriptionAction.adjust) {
    if ([2, 4, 8].includes(hours)) {
      return `recommended_${hours}_hours_monthly_description`;
    }
    if (hours < 2) {
      return 'recommended_less_than_2_hours_monthly_description';
    }
    if (hours > 8) {
      return 'recommended_more_than_8_hours_monthly_description';
    }
  }

  return `recommended_${isContract ? 'contract' : 'monthly'}_description`;
}

export default getProgramDescriptionTranslationKeys;
